import React, { Component } from 'react';
import { withNamespaces } from 'react-i18next';
import i18next from 'i18next';
import ProfileList from './ProfileList';
import styles from '../../../styles/profile.module.css';
import { isAuthenticated } from '../../../actions/authentication';
import { withCookies } from 'react-cookie';
import { RenewToken } from '../../../utils/token';
import { ChatContext } from '@/ChatProvider';

export class Profile extends Component {

    constructor(props) {
        super(props);

        this.state = { authenticated: false }
    }

    componentDidMount() {
        this.handleToken();
    }

    async handleToken() {
        await RenewToken(this.props);

        isAuthenticated().then((result) => {
            this.setState({ authenticated: result });
            this.context.setIsAuthenticated(result);
        });
    }

    render() {
        return (
            this.state.authenticated && <div className={styles.rootProfile}>
                <ProfileList />
            </div>
        );
    }
}

Profile.contextType = ChatContext;
export default withNamespaces(['menu'], { wait: true })(withCookies(Profile));